module.exports = __webpack_public_path__ + "media/128.30b60c2d.wav";